import { savePNG } from '~core/savePNG';
import { saveJPEG } from '~core/saveJPEG';
import { saveSVG } from '~core/saveSVG';
import { savePDF } from '~core/savePDF';
import { saveMP4 } from '~core/saveMP4';
import { getState } from '~src/state';
import { centerCanvas } from '~core';

const actionsMap = {
  MP4: saveMP4,
  PNG: savePNG,
  JPEG: saveJPEG,
  SVG: saveSVG,
  PDF: savePDF,
};

export const handleDownloadAction = () => {
  centerCanvas();

  // we need to toggle all magic frame editing modes off otherwise the editingImg gets exported in editing mode
  // also, we preserve the activeObject as when toggling the mode, the active object is unset
  const preservedActiveObject = window.canvas.getActiveObject();
  for (const object of window.canvas.getObjects()) {
    if (object.type === 'MagicFrame') {
      object.setEditMode(false);
    }
  }
  window.canvas.setActiveObject(preservedActiveObject);

  const downloadFileType = getState('submenu.export.downloadFileType');

  if (!downloadFileType) {
    throw new Error('Missing downloadFileType in handleDownloadAction');
  }

  if (!Object.keys(actionsMap).includes(downloadFileType)) {
    throw new Error('Invalid downloadFileType in handleDownloadAction');
  }

  const mappedFunction = actionsMap[downloadFileType];

  return mappedFunction();
};
